import { createElement } from 'react';

import logger from '@eneco/common/log';
import { ComponentRendering } from '@sitecore/types/lib';

type Props = {
  rendering: ComponentRendering;
};

function renderError(componentName: string) {
  return ({ rendering }: Props): ReturnType<typeof createElement> => {
    logger.error('OCiLDI', `Rendering for missing component ${componentName}`, { rendering });
    return createElement(
      'div',
      {
        style: { border: '1px inset red' },
      },
      `Missing component: ${componentName}`,
    );
  };
}

export default renderError;
